import { numberFormat } from './format';
import util from './util';
import { escapeReg, escapeMap } from './regexp';
const regBlank = / /g;

export default function(data, globalData = {}) {
    let currencySymbol = globalData.currencySymbol;
    let mlsOrgHas74 = data.mlsOrg?.mlsOrgHas74;
    let soldProtected = data.mlsOrg?.soldProtected || '';
    const listingPictures = data.listingPictures?.split?.('|') ?? [];
    let fmtData = {
        id: data.id,
        detailUrlTarget:
            this.platform.isMobile && util.inPopDetailPage
                ? '_self'
                : data.target ||
                  (data.soldDate
                      ? globalData.listingDetailSoldOpenStyle
                      : globalData.listingDetailOpenStyle) ||
                  '_self',
        link: this.platform.isReallyUser ? data.detailLink : data.detailUrl,
        detailUrl: data.detailUrl,
        preview: listingPictures?.[0] || '',
        status: data.listingStatus,
        tour3D: /matterport\.(com|cn)\/show/.test(
            `${data.link} ${data.chimeVideoLink}`
        ),
        picturesNum: data.picturesNum,
        collected: data.collectStatus,
        price: numberFormat(data.price, null, 2, currencySymbol + ' '),
        address: (data.address || '').replace(/, */g, ', '),
        streetAddress: data.streetAddress,
        propertyType: data.propertyTypeText || data.propertyType,
        // propertyTypeText: data.propertyTypeText,
        statusOrigin: (data.statusOrigin || '').toLowerCase(), //leased
        desc: data.detailsDescribe || '',
        listingPictures: data.listingPictures || '',
        previewPictures: listingPictures,
        //mls
        latitude: data.latitude,
        longitude: data.longitude,
        showMls: mlsOrgHas74 && data.mlsListingId,
        mlsid: data.mlsListingId,
        mlsLogo: this.platform.isMobile
            ? data.mlsOrg?.smallLogo || data.mlsOrg?.logo
            : data.mlsOrg?.logo,
        mlsOrgHas74: mlsOrgHas74,
        listingTags: data?.listingTags || [],
        exclusive: data?.exclusiveListingTag,
        // to be determined
        listingSource: data.listingSource,
        nodisclosureDes: data.nodisclosureDes,
        vow: !!soldProtected,
        // soldProtected like "Sold,Active,Pending"
        isProtected: soldProtected.includes(data.listingStatus),
        flagText: data.flagText,
        statusText: data.listingStatusText,
        addressPartialFlag: data.addressPartialFlag
    };
    let showListingPrice = globalData.house?.showListingPrice;
    fmtData.showListingPrice = showListingPrice;
    let houseForMls = globalData?.mlsOrgs?.find(mls => mls.id === data.mlsOrg?.id) || { showSoldPrice: 1 }
    let showSoldPrice = globalData.house?.showSoldPrice && houseForMls.showSoldPrice;
    fmtData.showSoldPrice = showSoldPrice && data.soldDate
    if (data.soldDate) {
        let initialPrice,
            soldPrice,
            markPrice;

        let { trend, trendUp } = getTrend(data.soldPrice, data.price);
        if (!showListingPrice && !showSoldPrice) {
            markPrice = soldPrice = '--';
            trend = '';
        } else {
            soldPrice = data.soldPrice;
            markPrice = !showSoldPrice ? data.price : soldPrice;
            initialPrice = data.price;
        }
        Object.assign(fmtData, {
            // soldDate: dateFormat('MM/dd/yyyy', data.soldDate, this.$pinia),
            soldDate: data.soldDate, // 在csr进行格式化时间
            soldPrice:
                soldPrice === '--'
                    ? '--'
                    : numberFormat(soldPrice, null, 2, `${currencySymbol} `),
            markPrice:
                markPrice === '--'
                    ? '--'
                    : numberFormat(markPrice, null, 2, `${currencySymbol} `),
            initialPrice: numberFormat(
                initialPrice,
                null,
                2,
                `${currencySymbol} `
            ),
            trendUp: trendUp,
            trend: trend
        });
        if (fmtData.trend === '0%') {
            fmtData.trend = '';
        }
    } else {
        // data.flag
        // fmtData.status  -> listingStatus
        let flag = data.flag || fmtData.status || '';
        let oldPrice = data.oldPrice || data.oldPriceValue; // The name of the old price field of Zhongtai Station and non-Zhongtai Station is different
        // Whether the regular matching status is open house， Display priority is open house > price reduced >  new/ new on site > active
        flag = (
            /open[-\s]house/i.test(flag)
                ? 'open-house'
                : data.listingStatus === 'Active' &&
                  data.mlsOrg.showPriceReduced &&
                  data.hasPriceChangedV1 === 1 &&
                  Math.round((oldPrice - data.price) / 1000) > 0 //hasPriceChangedV1===> 1 price reduction ，2 price increase
                    ? 'price-reduced'
                    : flag
        )
            .replace(regBlank, '-')
            .toLowerCase();
        let listingStatus = { soldDate: null };
        if (data.mlsOrgId == 11) {
            //SITE-16247 11 Number mls state customization of
            listingStatus.flag = fmtData.status;
        } else {
            listingStatus.flag = flag;
        }
        Object.assign(fmtData, listingStatus);
    }
    /** TODO：commercialRealEstate is true when propertyType in ["Retail-Commercial", "Office",
      "Industrial", "Business Opportunity", "Shopping Center", "Special Purpose", "Land", "Farm/Ranch"]
      */
    if (!util.isSSRServer && window.globalHouseDataFormat) {
        window.globalHouseDataFormat(fmtData);
    }
    // SITE-15435
    if (data.mlsOrg?.id == 128) {
        fmtData.soldDate = fmtData.flag = '';
    }
    //SITE-16247  109 Number mls Problems displayed in the lower right corner of the listing
    if (data.mlsOrg?.id == 109) {
        fmtData.imgNotZoom = true;
    } else {
        fmtData.imgNotZoom = false;
    }
    return fmtData;
}

// houseData的属性, 这些属性对应的值要通过mapHouseData方法map到组件上
const houseDataProps = [
    'id',
    'detailUrlTarget',
    'link',
    'detailUrl',
    'preview',
    'status',
    'tour3D',
    'picturesNum',
    'collected',
    'price',
    'streetAddress',
    'propertyType',
    'statusOrigin',
    'desc',
    'listingPictures',
    'previewPictures',
    'latitude',
    'longitude',
    'showMls',
    'mlsid',
    'mlsLogo',
    'mlsOrgHas74',
    'listingTags',
    'exclusive',
    'listingSource',
    'nodisclosureDes',
    'vow',
    'isProtected',
    'flagText',
    'statusText',
    'soldDate',
    'soldPrice',
    'markPrice',
    'initialPrice',
    'trendUp',
    'trend',
    'flag',
    'imgNotZoom',
    'showSoldPrice',
    'showListingPrice'
]
export const mapHouseData = function(houseDataKey) {
    const defaultComputeds = {
        address: function({ vowAddress }) {
            return vowAddress || this[houseDataKey].address
        }
    }
    return houseDataProps.reduce((reduced, key) => {
        reduced[key] = function() {
            return this[houseDataKey][key];
        }
        return reduced;
    }, defaultComputeds)
}

/**
 *  Numeric Internationalization + format
 * @param {*} count
 * @param {*} globalizationKey
 * @param {*} options.isNeedUnit=false
 * @param {*} options.Fixed=2
 * @param {*} options.split=" "
 * @returns
 */
export const numberGFormat = function(count, globalizationKey, options = {}) {
    let { isNeedUnit = false, Fixed = 2, split = ' ' } = options;
    let unit = this.$t(globalizationKey, { count });
    if (!unit) {
        return '';
    }
    return numberFormat(count, isNeedUnit, Fixed) + split + unit;
};


export const getTrend = (soldPrice, price) => {
    let trendUp = true;
    let trend  = (100 * (soldPrice - price)) / price;
    if (trend < 0) {
        trend = -trend;
        trendUp = false;
    }

    if (isNaN(trend) || !Number.isFinite(trend)) {
        trend = '';
    }
    // 旧的计算方式
    // trend  = trend ? numberFormat(trend, null, 1) + '%' : '';
    if (typeof trend == 'number') {
        trend  = trend.toFixed(1);
    }
    // 新的计算方式
    if (trend == '' || parseFloat(trend) == 0) {
        // toFixed  later may be   0  or   0.0
        trend = '';
    } else {
        trend = trend + '%';
    }

    return  {
        trend,
        trendUp
    }
}



/**
 *
 * @param {object} info house listing info
 * @param {boolean} isNeedUnit  Do you want to convert units  1000 -> 1k
 * @param {number} Fixed  keep a few decimal places
 * @param {string} split
 */
export const getSqftText = function(
    info,
    isNeedUnit = false,
    Fixed = 2,
    split = ' '
) {
    let text = '';
    let format = (count, key) => numberGFormat.call(this, count, key, { isNeedUnit, Fixed, split });
    if (info.propertyType == 'Vacant Land') {
        if (info.totalAvailableAcres > 0) {
            text = format(
                info.totalAvailableAcres / (10890 * 4),
                'common:house.acres'
            );
        }
    } else {
        if (info.sqft > 0) {
            text = format(info.sqft, 'common:house.sqft');
        } else if (info.totalAvailableAcres >= 10890) {
            text = format(
                info.totalAvailableAcres / (10890 * 4),
                'common:house.acresLot'
            );
        } else if (
            info.totalAvailableAcres > 0 &&
            info.totalAvailableAcres < 10890
        ) {
            text = format(info.totalAvailableAcres, 'common:house.sqftLot');
        }
    }
    return text;
};

export const getBasic = function(data) {
    if (data.commercialRealEstate) {
        const sqftUnit = this.$t('common:house.sqft', {
            count: data.sqft
        });
        let sqft = '';
        if (sqftUnit) {
            sqft = (data.sqft > -1 ? data.sqft : '-') + sqftUnit;
        }
        return [sqft, data.lotSizeWithUnit, data.pricePerSqft];
    } else {
        let split = ' ';
        let fixed = 2;
        let bedText =
            data.bedrooms < 1
                ? ''
                : numberGFormat.call(this, data.bedrooms, 'common:house.bed');

        let bathText =
            data.bathrooms < 1
                ? ''
                : numberGFormat.call(this, data.bathrooms, 'common:house.bath');
        let sqftText = getSqftText.call(this, data, false, fixed, split);
        let arr = [];
        if (bedText) {
            arr.push({ key: 'bed', text: bedText })
        }
        if (bathText) {
            arr.push({ key: 'bath', text: bathText })
        }
        if (sqftText) {
            arr.push({ key: 'sqft', text: sqftText })
        }
        return arr;
    }
};

function calcStringFromTemplate(templateSentence, info) {
    if (
        !templateSentence || //empty
        !/#([^{]*){(.*?)}([^#]*)#/.test(templateSentence) // has no variable
    ) {
        return templateSentence;
    }
    let hasInfoValue = false;
    let preHasValue = true;
    let ret = templateSentence.replace(
        /([^#]*)#([^{]*){(.*?)}([^#]*)#/gm,
        function(_, preDelimiter, leftStr, variableName, rightStr, startIdx) {
            let infoText = info[variableName];
            const curHasValue = !!infoText;
            const fullText = curHasValue ? leftStr + infoText + rightStr : '';
            try {
                if (startIdx == 0) {
                    return preDelimiter + fullText;
                }
                if (!curHasValue) {
                    return '';
                }
                if (!preHasValue) {
                    // If the previous variable has no value ， then the middle connector do not
                    preDelimiter = '';
                }
                if (!preDelimiter && !leftStr) {
                    // There is no gap between the previous value
                    return (hasInfoValue ? ' • ' : '') + fullText;
                }
                return preDelimiter + fullText;
            } finally {
                preHasValue = curHasValue;
                hasInfoValue = hasInfoValue || curHasValue;
            }
        }
    );
    // all variable not exist, then not show the sentense
    return hasInfoValue ? ret : '';
}
function handleTemplateStr(template, info, delimiter) {
    if (!template) {
        return '';
    }
    let templateSentences = template.split('<br>');
    return templateSentences
        .map(templateSentence => calcStringFromTemplate(templateSentence, info))
        .filter(v => v)
        .join(delimiter);
}

export function getProviderHtml(template, info) {
    return handleTemplateStr(template, info, '<br>');
}

export function getProviderText(template, info) {
    let templateStr = (template || '').replace(
        RegExp(escapeReg, 'g'),
        function(matcher) {
            return escapeMap[matcher];
        }
    );
    return handleTemplateStr(templateStr, info, '\n');
}

export const getFlagtext = function({ house, fmtData, globalData }) {
    if (house.mlsOrg?.id == 128) {
        return '';
    }
    if (house.soldDate) {
        return null;
    }
    if (house.mlsOrgId == 11) {
        //SITE-16247 11 Number mls state customization of
        return fmtData.statusText || fmtData.status;
    }
    if (fmtData.flag === 'open-house' && house.openHouseDesc) {
        return house.openHouseDesc;
    }
    if (fmtData.flag === 'price-reduced') {
        // Markdown Copywriting
        let currencySymbol = globalData.currencySymbol;
        let price = Math.round(
            ((house.oldPrice || house.oldPriceValue) - house.price) /
                1000
        );
        if (price >= 1000) {
            return this.$t('common:house.priceDroppedByM', {
                price:
                    currencySymbol + (price / 1000).toFixed(1)
            });
        } else {
            return this.$t('common:house.priceDroppedBy', {
                price:
                    currencySymbol + price
            });
        }
        
    }
    if (house.mlsOrg?.mlsOrgHas74 && fmtData.flag === 'new') {
        return this.$t('common:house.newToSite');
        // 'new to site';
    }
    return house.flagText || fmtData.statusText || house.flag || fmtData.status;
};
